//@ts-check
import { Grid, Typography } from '@material-ui/core';
import { DataGrid, Modals, Button, DataAction } from 'ecrion-components';
import React, { useEffect } from 'react';

var EmailBlacklist = function EmailBlacklist() {
  useEffect(function () {
    document.title = 'Settings � Email Blacklist � Ecrion';
  }, []);
  return React.createElement(React.Fragment, null, React.createElement(Typography, {
    variant: "h6"
  }, "Email Blacklist"), React.createElement(Grid, {
    container: true
  }, React.createElement(Grid, {
    item: true,
    xs: true
  }), React.createElement(Grid, {
    item: true
  }, React.createElement(Button, {
    onClick: function onClick() {
      Modals.open({
        type: Modals.TYPES.PROMPT_INPUT,
        props: {
          windowProps: {
            header: 'Add Email Domain To Blacklist',
            hasCloseIcon: true,
            style: {
              width: '50%'
            }
          },
          formFieldType: 'Domain',
          formField: {
            label: 'Domain'
          },
          submitLabel: 'Save',
          submittingLabel: 'Saving...',
          onSubmit: function onSubmit(data) {
            return DataAction.item({
              dataType: 'emailBlacklist'
            }).create({
              Name: data
            });
          }
        }
      });
    }
  }, "New")), React.createElement(Grid, {
    item: true,
    xs: 12
  }, React.createElement(DataGrid, {
    id: "email-blacklist",
    dataType: "emailBlacklist",
    viewProps: {
      hideModeSwitcher: true
    },
    styles: {
      elevation: 0,
      hideBorder: true
    },
    contextMenu: [{
      type: 'delete',
      onClick: function onClick(e, item) {
        DataAction.item({
          dataType: 'emailBlacklist',
          id: item.Name
        }).delete({
          useConfirmation: true
        });
      }
    }]
  }))));
};

export default EmailBlacklist;